module.exports = __webpack_public_path__ + "80d4357ce16c4ca2282dec8b456ba79b.MP3";